import { render } from "./SelectOption.vue?vue&type=template&id=dae6c6b6&scoped=true"
import script from "./SelectOption.vue?vue&type=script&lang=js"
export * from "./SelectOption.vue?vue&type=script&lang=js"

import "./SelectOption.vue?vue&type=style&index=0&id=dae6c6b6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae6c6b6"]])

export default __exports__